module.exports = __webpack_public_path__ + "img/fruit-tomatillos-190x100.52f14714.jpg";